// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","Photos__row":"sp_a bhc_a bhc_r bhc_j","Photos__img":"sp_b bhc_b"};